import api from './api';

export const subcontractorService = {
  getAll: (params = {}) => api.get('/subcontractors/', { params }),
  getById: (id) => api.get(`/subcontractors/${id}`),
  create: (data) => api.post('/subcontractors/', data),
  update: (id, data) => api.put(`/subcontractors/${id}`, data),
  delete: (id) => api.delete(`/subcontractors/${id}`),
};
